import { AbstractSocialService } from './AbstractSocialService';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { Singleton } from '@denishussar/html5-game-engine';

declare var API_callback;

@Singleton
export class OKSocialService extends AbstractSocialService {
    addToFavorite(): Promise<any> {
        return Promise.reject('Not have this method in OK');
    }

    getAllowNotification(): Promise<any> {
        return Promise.reject('Not have this method in OK');
    }

    showInviteOneUser(uid: number): Promise<void> {
        return Promise.reject('Not have this method in OK');
    }

    readonly GAME_LINK_OK = 'https://vk.com/app7979319_676657198';
    readonly GROUP_ID_OK = 462084990;

    protected userInfo = {};

    protected data: any;

    async initApp() {
        console.log('OK service init start');
        // @ts-ignore
        const data = await FAPI.Util.getRequestParameters();
        console.log(data);
        // @ts-ignore
        await FAPI.init(
            data.api_server,
            data.apiconnection,
            () => {console.log('OK API Init');},
            () => {console.log('OK API Init Fail');},
        );
        this.userInfo = data;

        API_callback = (method, result, data) => {
            // обработка ответов от методов ОК
            console.log('[CALL BACK]:::', method, result);
        };

        return this.userInfo;
    }

    async postMessage(message: string, attachments: string = '') {
        // @ts-ignore
        const data = await FAPI.UI.postMediatopic(
            {
                'media': [
                    {
                        'type': 'text',
                        'text': message,
                    },
                    {
                        'type': 'link',
                        'url': this.GAME_LINK_OK,
                    },
                ],
            },
            false,
        );
    }

    async getFriends() {
        //note: опять, в одном случае есть колбек, в другом нет.
        //todo: переработать метод, чтобы привести к общему виду
        const callBack = () => console.log('ИСПРАВЬ МЕНЯ');
        const callbackCurrentUserFriends = async (status, data, error) => {
            if (data) {
                // @ts-ignore
                await FAPI.Client.call(
                    {
                        'method': 'users.getInfo',
                        'fields': 'first_name,last_name,pic128x128',
                        'uids': data,
                    },
                    callbackFriendsInfo,
                );
            } else {
                console.log(error);
            }
        };
        const callbackFriendsInfo = (status, data, error) => {
            console.log(data);
            // callBack(data);
        };
        // @ts-ignore
        const friends = await FAPI.Client.call({ 'method': 'friends.get' }, callbackCurrentUserFriends);
    }

    async showNotification() {
        // @ts-ignore
        const notification = await FAPI.UI.showNotification('Поиграй в мою игру!', 'arg1=val1');
        return notification;
    }

    async showInvite() {
        //note: занес параметры внутрь, чтобы выделить общий интерфейс
        //todo: разобраться с параметрами, привести к общему виду всё
        const text: string = '';
        const params: string = '';
        const selectedIds: [] = [];
        // @ts-ignore
        const invite = await FAPI.UI.showInvite(text, params, selectedIds);
        return invite;
    }

    async joinGroup() {
        // @ts-ignore
        const join = await FAPI.invokeUIMethod('joinGroup', this.GROUP_ID_OK);
    }

    public getToken() {
        console.log('getToken ok');
        return httpsCallable<{
            logged_user_id: number,
            session_key: string,
            auth_sig: string,
        }, string>(getFunctions(), 'getTokenForOK')({//@ts-ignore //todo: add normal types
            logged_user_id: this.userInfo.logged_user_id, //@ts-ignore //todo: add normal types
            session_key: this.userInfo.session_key, //@ts-ignore //todo: add normal types
            auth_sig: this.userInfo.auth_sig,
        });
    }
}